export default "__VITE_ASSET__DrCJcFDy__"